(() => {
  if (window.countrylookGoldReady) return;
  window.countrylookGoldReady = true;
  const all = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  let abort;
  function element(tag, className, text) {
    const el = document.createElement(tag);
    el.className = className;
    if (text) el.textContent = text;
    return el;
  }
  function init() {
    abort?.abort();
    const root = document.querySelector('.cl-gold');
    if (!root) return;
    abort = new AbortController();
    const options = {signal:abort.signal};
    const labels = JSON.parse(root.dataset.goldLabels);
    const track = root.querySelector('.cl-gold-track');
    track.replaceChildren();
    all('.cl-award-card[data-medal="Gold"]').forEach((award, i) => {
      const category = award.closest('.cl-category');
      const item = element('div','cl-gold-item');
      item.setAttribute('role','listitem');
      const link = element('a','cl-gold-card');
      link.href = '#' + award.id;
      link.dataset.goldTarget = award.id;
      link.id = 'gold-card-' + i;
      const source = award.querySelector('.cl-winner-image');
      if (source) {
        const img = source.cloneNode();
        img.className = 'cl-gold-image';
        img.alt = '';
        img.loading = 'lazy';
        img.sizes = '(min-width: 1000px) 350px, 85vw';
        link.append(img);
      } else link.classList.add('cl-gold-card--type');
      const copy = element('div','cl-gold-copy');
      const custom = category.dataset.goldCategory;
      copy.append(element('p','cl-gold-category', custom && custom !== category.id ? custom : labels[category.id] || category.querySelector('.cl-category-editorial')?.textContent));
      copy.append(element('p','cl-gold-medal',root.dataset.goldLabel));
      copy.append(element('h3','cl-gold-name',award.querySelector('.cl-name').textContent));
      copy.append(element('span','cl-gold-read',root.dataset.readLabel + ' →'));
      link.append(copy);
      item.append(link);
      track.append(item);
      let back = award.querySelector('.cl-back-gold');
      if (!back) {
        back = element('a','cl-back-gold',root.dataset.backLabel);
        back.href = '#gold-winners';
        award.querySelector('.cl-story-actions').append(back);
      }
      back.dataset.returnGold = link.id;
    });
    root.hidden = !track.children.length;
    const prev = root.querySelector('[data-gold-prev]');
    const next = root.querySelector('[data-gold-next]');
    const position = root.querySelector('.cl-gold-position');
    const step = () => (track.children[1]?.offsetLeft || 0) - (track.children[0]?.offsetLeft || 0) || track.clientWidth;
    const update = () => {
      const index = Math.min(track.children.length,Math.round(track.scrollLeft / step()) + 1);
      position.textContent = index + ' ' + root.dataset.ofLabel + ' ' + track.children.length;
      prev.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    };
    const move = direction => track.scrollBy({left:direction * step(),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    prev.addEventListener('click',()=>move(-1),options);
    next.addEventListener('click',()=>move(1),options);
    track.addEventListener('scroll',update,{...options,passive:true});
    window.addEventListener('resize',update,options);
    track.addEventListener('keydown',event=>{
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      const cards=all('.cl-gold-card',track);
      const index=cards.indexOf(document.activeElement);
      if(index<0)return;
      event.preventDefault();
      const target=event.key==='Home'?0:event.key==='End'?cards.length-1:Math.max(0,Math.min(cards.length-1,index+(event.key==='ArrowRight'?1:-1)));
      cards[target].focus({preventScroll:true});
      track.scrollTo({left:target*step(),behavior:'instant'});
    },options);
    update();
  }
  document.addEventListener('click', event => {
    const gold = event.target.closest('[data-gold-target]');
    if (gold && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      try { history.pushState(null,'',gold.getAttribute('href')); } catch {}
      const award=document.getElementById(gold.dataset.goldTarget);
      const story=award.querySelector('.cl-winner');
      story.open=true;
      const reading=story.querySelector('.cl-reading');
      reading.setAttribute('tabindex','-1');
      requestAnimationFrame(()=>{
        reading.scrollIntoView({block:'start',behavior:'instant'});
        reading.focus({preventScroll:true});
      });
    }
    const back = event.target.closest('[data-return-gold]');
    if (back) {
      event.preventDefault();
      try { history.pushState(null,'','#gold-winners'); } catch {}
      const root=document.querySelector('.cl-gold');
      const card=document.getElementById(back.dataset.returnGold);
      const track=root.querySelector('.cl-gold-track');
      track.scrollTo({left:card.parentElement.offsetLeft-track.children[0].offsetLeft,behavior:'instant'});
      root.scrollIntoView({block:'start',behavior:'instant'});
      card.focus({preventScroll:true});
    }
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(init));
  document.addEventListener('shopify:section:reorder',init);
})();
